export const SET_INTEGRATIONS = 'SET_INTEGRATIONS';
export const CLEAR_INTEGRATIONS = 'CLEAR_INTEGRATIONS';
export const SET_INTEGRATIONS_LIST_LOADING = 'SET_INTEGRATIONS_LIST_LOADING';
export const SET_INTEGRATIONS_LIST_OPTIONS = 'SET_INTEGRATIONS_LIST_OPTIONS';
export const CLEAR_INTEGRATIONS_LIST_OPTIONS = 'CLEAR_INTEGRATIONS_LIST_OPTIONS';
export const SET_INTEGRATION_OPTIONS_LIST = 'SET_INTEGRATION_OPTIONS_LIST';
export const CLEAR_INTEGRATION_OPTIONS_LIST = 'CLEAR_INTEGRATION_OPTIONS_LIST';
export const SET_INTEGRATION_DETAILS = 'SET_INTEGRATION_DETAILS';
export const CLEAR_INTEGRATION_DETAILS = 'CLEAR_INTEGRATION_DETAILS';
export const SET_INTEGRATION_DETAILS_FOR_EDIT = 'SET_INTEGRATION_DETAILS_FOR_EDIT';
export const CLEAR_INTEGRATION_DETAILS_FOR_EDIT = 'CLEAR_INTEGRATION_DETAILS_FOR_EDIT';
export const SET_INTEGRATION_TESTING_LOADING = 'SET_INTEGRATION_TESTING_LOADING';
export const CLEAR_INTEGRATION_TESTING_LOADING = 'CLEAR_INTEGRATION_TESTING_LOADING';
export const SET_INTEGRATION_BY_CATEGORY = 'SET_INTEGRATION_BY_CATEGORY';
export const CLEAR_INTEGRATION_BY_CATEGORY = 'CLEAR_INTEGRATION_BY_CATEGORY';
